import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Moon = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M12 22c4.106 0 8.78-2.089 9.964-6.754a1.002 1.002 0 0 0-.97-1.246C15.521 14 10 10.599 10 3a1 1 0 0 0-1.242-.971C4.115 3.186 2 8.009 2 12c0 5.514 4.486 10 10 10zM8.061 4.4c.572 6.44 5.095 10.966 11.532 11.538C18.233 18.733 14.944 20 12 20c-4.411 0-8-3.589-8-8 0-2.861 1.28-6.233 4.061-7.6z", key: "k0" })));
});
Moon.displayName = 'Moon';
export var MoonDimensions = { height: 24, width: 24 };
